@if (layout === "standalone") {
  <div class="relative">
    @if (userFeedUnseenItemCount() > 0) {
      <div
        class="absolute right-0 top-0 z-50 block aspect-square w-2.5 rounded-full bg-interface-positive-default"
      >
        <div
          class="absolute inset-0 animate-ping rounded-full bg-interface-positive-default"
        ></div>
      </div>
    }
    <p-button
      size="small"
      pTooltip="Notifications"
      tooltipPosition="left"
      (click)="userFeedPopover.toggle($event)"
    >
      <ng-template #icon>
        <svg-icon src="assets/icons/general/social-bell.svg" />
      </ng-template>
    </p-button>
  </div>
}

@if (layout === "menu") {
  <p-button
    variant="text"
    severity="contrast"
    styleClass="w-full !justify-start"
    (click)="userFeedPopover.toggle($event)"
  >
    <svg-icon src="assets/icons/general/social-bell.svg" />
    <span>Notifications</span>
    <div
      class="typography-labels-medium-emphasis ml-auto grid h-6 place-items-center rounded-full bg-interface-primary-100 px-1 text-interface-primary-color"
    >
      {{ userFeedUnseenItemCount() }}
    </div>
  </p-button>
}

<p-popover
  #userFeedPopover
  (onShow)="onUserFeedPopoverShow()"
  (onHide)="onUserFeedPopoverHide()"
>
  <ul class="flex flex-col gap-2">
    <!-- close button -->
    <p-button
      class="absolute right-2 top-2"
      size="small"
      severity="secondary"
      variant="text"
      (click)="userFeedPopover.hide()"
      pTooltip="Close"
      tooltipPosition="left"
    >
      <ng-template #icon>
        <svg-icon src="assets/icons/general/close.svg" />
      </ng-template>
    </p-button>

    <li class="typography-headings-small p-1">Notifications</li>
    @if (error()) {
      <div class="rounded bg-red-50 p-3 text-sm text-red-800">
        {{ error() }}
      </div>
    }
    <ul
      class="flex max-h-[300px] flex-col gap-2 overflow-y-auto pr-3"
      #userFeedContainer
      (scroll)="onUserFeedScroll($event)"
    >
      @if (isInitialLoading()) {
        <ng-container *ngTemplateOutlet="notificationsLoading" />
      } @else {
        @for (userFeedItem of userFeedEdges; track userFeedItem.node.id) {
          <ng-container
            *ngTemplateOutlet="
              notificationItem;
              context: { $implicit: userFeedItem }
            "
          />
        }
        @if (isLoading()) {
          <ng-container *ngTemplateOutlet="notificationsLoading" />
        }
        @if (userFeedEdges.length === 0 && !isInitialLoading()) {
          <ng-container *ngTemplateOutlet="notificationsEmpty" />
        }
      }
    </ul>
  </ul>
</p-popover>

<ng-template #notificationsEmpty>
  <div class="flex flex-col items-center gap-3 p-5">
    <svg-icon
      svgClass="h-10 w-10"
      src="assets/icons/general/envelope-open.svg"
    />
    <div class="text-center">
      <h3 class="text-lg">You have no notifications</h3>
      <span class="text-sm">
        When you get a notification they'll show up here.
      </span>
    </div>
  </div>
</ng-template>

<ng-template #notificationsLoading>
  <div
    class="grid grid-cols-[4ch_auto] items-center gap-3 rounded p-2 text-left"
  >
    <ag1-loader class="scale-50" />
    <div class="flex flex-col gap-0.5">
      <span>Loading Notifications...</span>
      <span>Please wait</span>
    </div>
  </div>
</ng-template>

<ng-template #notificationItem let-userFeedItem>
  <button
    class="cursor-pointer rounded bg-interface-common-color p-2 text-left hover:bg-interface-common-hover"
    (click)="onUserFeedItemClick(userFeedItem.node)"
  >
    <div class="grid grid-cols-[4ch_auto] gap-3">
      <span class="p-3">
        @if (!userFeedItem.node.read) {
          <svg-icon src="assets/icons/general/envelope.svg" />
        }
        @if (userFeedItem.node.read) {
          <svg-icon src="assets/icons/general/envelope-open.svg" />
        }
      </span>

      <div class="flex flex-col gap-0.5">
        <span>{{ userFeedItem.node.message }}</span>
        <span class="text-text-common-base">
          {{ userFeedItem.node.createdAt | timeAgo | async }}
        </span>
      </div>
    </div>
  </button>
</ng-template>
